<template>
  <div
    :class="['layer', { active: isActive }]"
    @click="setActiveLayer({ layerId: layer.id })"
  >
    <div class="header">
      <div class="meta flex-row-align-center">
        <icon size="20">timelapse</icon>
        <span>Time Spent</span>
      </div>
      <div class="controls flex-row-align-center">
        <icon size="18" @click="$emit('editLayer', layer)">edit</icon>
        <icon size="18" @click="$emit('deleteLayer', layer)">delete</icon>
      </div>
    </div>
    <div class="metric">
      <span>{{ layer.name }}</span>
      <span>15.3 mins</span>
    </div>
    <div class="footer">
      <!-- <icon size="18">linear_scale</icon> -->
      <icon size="18">timeline</icon>
      <span>{{ layer.start_event.name }}</span>
      <icon size="18" class="arrow-icon">arrow_right_alt</icon>
      <span>{{ layer.end_event.name }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    isActive: Boolean,
    layer: Object,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("StaticEntity", ["setActiveLayer"]),
  },
};
</script>

<style lang="scss" scoped>
.layer {
  background: var(--color-secondary);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  border-left: 3px solid transparent;

  &.active {
    border-left: 3px solid var(--color-primary);
  }

  &:hover {
    cursor: pointer;
    background: var(--color-secondary-light);

    .controls {
      opacity: 1 !important;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .meta {
      color: var(--color-primary);

      i {
        margin-right: 5px;
      }

      span {
        font-size: 0.8em;
      }
    }

    .controls {
      opacity: 0;

      i {
        padding: 5px;
        margin: 0;
        border-radius: 50%;
        /* margin-left: 5px; */
        transition: 0.3s all ease-in-out;

        &:hover {
          background: var(--color-primary-light);
          color: var(--color-primary);
          cursor: pointer;
        }

        &:active {
          transform: scale(0.9);
        }

        &.active {
          background: var(--color-primary-light);
          color: var(--color-primary);
        }

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  .metric {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px 0;

    span {
      font-size: 1em;
    }
  }

  .footer {
    display: flex;
    align-items: center;

    i {
      margin-right: 5px;
    }

    span {
      font-size: 0.8em;
    }

    .arrow-icon {
      margin: 0 5px;
    }
  }
}
</style>
